/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelinboxselect2Inputs */

const en_channelinboxselect2 = /** @type {(inputs: Channelinboxselect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a conversation to read and reply.`)
};

const de_channelinboxselect2 = /** @type {(inputs: Channelinboxselect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle eine Unterhaltung zum Lesen und Antworten.`)
};

/**
* | output |
* | --- |
* | "Select a conversation to read and reply." |
*
* @param {Channelinboxselect2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelinboxselect2 = /** @type {((inputs?: Channelinboxselect2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelinboxselect2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelinboxselect2(inputs)
	return de_channelinboxselect2(inputs)
});
export { channelinboxselect2 as "channelInboxSelect" }